import { useSelector } from "react-redux";
import { RootState } from "../store/store";

export default function GameLogs() {
    const { deadView } = useSelector((state: RootState) => state.game);

    if((deadView?.logs?.length || 0) === 0){
        return <div>No logs...</div>
    }

    const logsReversed = [... deadView!.logs].reverse();
    return <div className='mafia-list-container mafia-role-description regular-text'>
        {logsReversed.map((line, index) => {
            const logLine = line.replace(/(\d+)/g, '<span class="mark">$1</span>');
            return <div key={index}><span className="mark">-</span> <span dangerouslySetInnerHTML={{ __html: logLine }} /></div>
        })}
    </div>
}